const env = require('amfe-env');
const browser = {
  get env() {
    return env;
  },
  get ua() {
    return window.navigator.userAgent;
  },
  get width() {
    return window.screen.width;
  },
  get height() {
    return window.screen.height;
  },
  get web() {
    var os = this.env.os;
    return !(os.ios || os.android || this.weiXin || this.rsApp || this.weiboApp);
  },
  get android() {
    var os = this.env.os;
    return !!os.isAndroid;
  },
  get ios() {
    var os = this.env.os;
    return !!os.isIPhone;
  },
  get iPhoneX() {
    if (this.ios) {
      var min = Math.min(this.width, this.height);
      var max = Math.max(this.width, this.height);
      // iphone x and xs
      if (min === 375 && max === 812) {
        return true;
      }
      // iphone xs max
      if (min === 414 && max === 896) {
        return true;
      }
      // iphone 12 mini / 13 mini
      if (min === 360 && max === 780) {
        return true;
      }
      // iphone 12 / 12 Pro / 13 / 13 Pro
      if (min === 390 && max === 844) {
        return true;
      }
      // iphone 12 Pro Max / 13 Pro Max
      if (min === 428 && max === 926) {
        return true;
      }
    }
    return false;
  },
  // 云闪付小程序
  get ysfMiniprogram() {
    // return true;
    return (/CloudPay/gi.test(this.ua));
  },
  // UC浏览器
  get UCBrowser() {
    return (/UCBrowser/gi.test(this.ua));
  },
  // 微信
  get weiXin() {
    var thirdapp = this.env.thirdapp;

    return !!thirdapp.isWeixin;
  },
  // 微信小程序
  get wxMiniprogram() {
    return window.__wxjs_environment === 'miniprogram';
  },
  // 微博App
  get weiboApp() {
    var thirdapp = this.env.thirdapp;
    return !!thirdapp.isWeibo;
  },
  // 企业微信
  get qiWei() {
    return (/wxwork/i.test(this.ua));
  },
  // QQ内置浏览器
  get qqApp() {
    var ua = this.ua,
      ios = this.ios,
      android = this.android;

    if (ios && /MQQBrowser/i.test(ua)) {
      return true;
    } else if (android && /Mobile MQQBrowser/i.test(ua)) {
      return true;
    }
    return false;
  },
  // 移动 QQ浏览器
  get qqMobile() {
    var ua = this.ua,
      ios = this.ios,
      android = this.android;

    if (ios && /QQ/i.test(ua)) {
      return true;
    } else if (android && /Mobile MQQBrowser/i.test(ua)) {
      return true;
    }
    return false;
  },
  // PC QQ浏览器
  get qqBrowser() {
    var browser = this.env.browser;

    return !!browser.isQQ;
  }
}

export default browser;